import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import RoomInformation from '../RoomInformation';
import RoomPopups from '../RoomPopups';

const BottomFloatArea = ({
  betPopups,
  displayPoint,
  joinPopups,
  messages,
  pointChangeAmount,
  responsiveMode,
}) => {
  const [highlightColor, setHighlightColor] = useState('transparent');
  const [showChange, setShowChange] = useState(false);
  const pointChangeValue = typeof pointChangeAmount === 'object'
    ? Number(pointChangeAmount?.amount ?? 0)
    : Number(pointChangeAmount);
  const pointChangeLabel = typeof pointChangeAmount === 'object'
    ? pointChangeAmount?.label
    : null;
  const pointChangeType = typeof pointChangeAmount === 'object'
    ? pointChangeAmount?.type
    : null;
  const hasPointChange = pointChangeAmount !== null && pointChangeAmount !== undefined;

  useEffect(() => {
    if (pointChangeAmount === null || pointChangeAmount === undefined) {
      setHighlightColor('transparent');
      setShowChange(false);
      return undefined;
    }

    if (pointChangeAmount !== null && pointChangeAmount !== undefined) {
      if (pointChangeType === 'bet_cancel') {
        setHighlightColor('rgba(96, 125, 139, 0.18)');
        setShowChange(true);
      } else if (pointChangeValue > 0) {
        setHighlightColor('rgba(33, 150, 243, 0.2)');
        setShowChange(true);
      } else if (pointChangeValue < 0) {
        setHighlightColor('rgba(244, 67, 54, 0.2)');
        setShowChange(true);
      }

      const timer = setTimeout(() => {
        setHighlightColor('transparent');
        setShowChange(false);
      }, pointChangeType === 'bet_cancel' ? 3000 : 10000);

      return () => clearTimeout(timer);
    }
  }, [pointChangeAmount, pointChangeType, pointChangeValue]);

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        zIndex: '1001',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          backgroundColor: '#fff',
          borderTop: '1px solid #e0e0e0',
          padding: '8px 12px',
          boxShadow: '0 -4px 12px rgba(0, 0, 0, 0.08)',
        }}
      >
        <Box sx={{ fontSize: '14px', color: '#333' }}>
          ルームチップ:
          <Box
            component="span"
            sx={{
              position: 'relative',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: highlightColor,
              transition: 'background-color 0.3s ease',
              padding: '2px 4px',
              borderRadius: '3px',
              minWidth: '2.5em',
            }}
          >
            {displayPoint}
            {hasPointChange && (
              <Box
                component="span"
                sx={{
                  position: 'absolute',
                  top: '-45%',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  fontSize: '15px',
                  fontWeight: 'bold',
                  color: pointChangeType === 'bet_cancel'
                    ? '#455a64'
                    : pointChangeValue > 0 ? '#1976d2' : '#d32f2f',
                  opacity: showChange ? 1 : 0,
                  transition: pointChangeType === 'bet_cancel' ? 'opacity 1.5s ease' : 'opacity 5s ease',
                  pointerEvents: 'none',
                  whiteSpace: 'nowrap',
                  zIndex: 1,
                }}
              >
                {pointChangeLabel || (pointChangeValue > 0 ? `+${pointChangeValue}` : pointChangeValue)}
              </Box>
            )}
          </Box>
          {'pt'}
        </Box>

      </Box>

      <RoomPopups joinPopups={joinPopups} betPopups={betPopups} responsiveMode={responsiveMode} />
      <RoomInformation messages={messages} />
    </Box>
  );
};

export default BottomFloatArea;
